import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImgSlider = ({ FirstImg, SecondImg, ThirdImg }) => {
  const settings = {
    dots: true,
    speed: 550,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  };

  return (
    <Carousel {...settings}>
      <Wrap>
        <img src={FirstImg} alt="" />
      </Wrap>
      <Wrap>
        <img src={SecondImg} alt="" />
      </Wrap>
      <Wrap>
        <img src={ThirdImg} alt="" />
      </Wrap>
    </Carousel>
  );
};

export default ImgSlider;

const Carousel = styled(Slider)`
  width: 95%;
  height: 70%;
  justify-content: center;
  align-items: center;

  @media (max-width: 968px) {
    width: 90%;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    width: 85%;
    margin-bottom: 20px;
    margin-top: 0;
  }

  @media (max-width: 480px) {
    width: 95%;
    margin-bottom: 15px;
  }

  .slick-dots {
    bottom: -40px;
    text-align: center;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex !important;
    justify-content: center;
    align-items: center;
    gap: 8px;

    @media (max-width: 768px) {
      bottom: -35px;
      gap: 6px;
    }

    @media (max-width: 480px) {
      bottom: -30px;
      gap: 5px;
    }

    li {
      margin: 0;
      width: auto;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;

      button {
        width: 12px;
        height: 12px;
        padding: 0;
        border-radius: 50%;
        border: none;
        background: rgba(0, 0, 0, 0.3);
        cursor: pointer;
        position: relative;

        @media (max-width: 768px) {
          width: 10px;
          height: 10px;
        }

        @media (max-width: 480px) {
          width: 8px;
          height: 8px;
        }

        &:before {
          display: none;
        }
      }

      &.slick-active button {
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }

  button.slick-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;

    @media (max-width: 768px) {
      top: 70%;
      margin: 0px 10px;
    }

    @media (max-width: 480px) {
      margin: 0px 5px;
    }

    &.slick-prev {
      left: -30px;
      @media (max-width: 768px) {
        left: -20px;
      }
      @media (max-width: 480px) {
        left: -15px;
      }
    }

    &.slick-next {
      right: -30px;
      @media (max-width: 768px) {
        right: -20px;
      }
      @media (max-width: 480px) {
        right: -15px;
      }
    }

    &::before {
      color: black;
      font-size: 20px;
      @media (max-width: 768px) {
        font-size: 16px;
      }
      @media (max-width: 480px) {
        font-size: 14px;
      }
    }
  }
`;

const Wrap = styled.div`
  border: 4px solid transparent;
  img {
    border-radius: 4px;
    width: 100%;
    height: 50vh;
    position: relative;
    object-fit: contain;
    transition-duration: 300ms;

    @media (max-width: 968px) {
      height: 40vh;
    }

    @media (max-width: 768px) {
      width: 100%;
      height: 30vh;
    }

    @media (max-width: 480px) {
      height: 25vh;
    }
  }
`;
